import React from "react";

const ControlQuestions = () => {
  return <text>ControlQuestions</text>;
};

export default ControlQuestions;
